const GlobalActionTypes = {
  CHANGE_SHOWING_STATUS_BANNER: 'change_showing_status_banner',
};

const GlobalReducer = (state, action) => {
  switch (action.type) {
    case GlobalActionTypes.CHANGE_SHOWING_STATUS_BANNER:
      return {
        ...state,
        isShowingStatusBanner: action.payload,
      };
    default:
      return state;
  }
};

const changeShowingStatusBanner = (dispatch) => (isShowing) =>
  dispatch({ type: GlobalActionTypes.CHANGE_SHOWING_STATUS_BANNER, payload: isShowing });

// eslint-disable-next-line import/prefer-default-export
export const global = {
  GlobalReducer,
  actions: {
    changeShowingStatusBanner,
  },
};
